module.exports = __webpack_public_path__ + "img/vanGoghPainting3.1fe8a692.jpg";